import type { ReactNode } from "react";
import { Card } from "@grackle/ui";

/** One headline number on the admin Overview and Settings: label, value, optional caption. */
export function Stat({ label, value, caption }: { label: string; value: ReactNode; caption?: ReactNode }) {
  return (
    <Card size="sm" className="admin-stat">
      <span className="gk-sm">{label}</span>
      <span className="gk-h2 admin-stat__value">{value}</span>
      {caption ? <span className="gk-caption">{caption}</span> : null}
    </Card>
  );
}
